import { Button } from './ui/button';
import { Card, CardContent } from './ui/card';

// Full-page redirect into the worker's OIDC start. Cookie is set on callback;
// App re-probes GET /session after return.
const AUTH_BASE = (import.meta.env.VITE_API_BASE ?? '') + '/api/auth';

export function AuthPortal() {
  const signIn = () => {
    const returnTo = encodeURIComponent(window.location.pathname || '/');
    window.location.href = `${AUTH_BASE}/login?returnTo=${returnTo}`;
  };

  return (
    <main className="grid min-h-dvh place-items-center bg-background px-4">
      <Card className="w-full max-w-md">
        <CardContent className="space-y-6 p-8">
          <div className="space-y-2 text-center">
            <div className="text-[10px] font-bold uppercase tracking-wider text-muted-foreground">
              Nim AI
            </div>
            <h1 className="text-2xl font-extrabold tracking-tight text-foreground">
              Sign in to Nim AI
            </h1>
            <p className="text-sm text-muted-foreground">
              Use your Zworks Keycloak account. Access is provisioned by your org admin.
            </p>
          </div>
          <Button className="w-full" size="lg" onClick={signIn} id="btn-sso-signin">
            Sign in with Zworks
          </Button>
        </CardContent>
      </Card>
    </main>
  );
}
